import React from "react";
import { CircularProgress } from "@material-ui/core";
import { observer } from "mobx-react-lite";

type ProgressProps = {
    isLoading: boolean;
};

const Progress = observer((props: ProgressProps) => {
    return (
        <div>
            {   props.isLoading &&
                <div style={{
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    height: '100%',
                    width: '100%',
                    background: 'rgba(0,0,0,0.3)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 1000
                }}>
                <CircularProgress disableShrink/>
            </div>}
        </div>
    );
});

export default Progress;